import { CustomEventType } from '@/features/types'

export const handleShowPageLoading = () => {
    const openEvent = new CustomEvent(CustomEventType.ShowPageLoading, {
        bubbles: true,
    })

    document.dispatchEvent(openEvent)
}

export const handleHidePageLoading = () => {
    const openEvent = new CustomEvent(CustomEventType.HidePageLoading, {
        bubbles: true,
    })

    document.dispatchEvent(openEvent)
}
